module.exports = __webpack_public_path__ + "static/media/itemMob.f85bf7d1.png";